// The kernel restarts on a board switch; the host owns this layer so the
// screen never goes blank.
export function createCurtain({ doc = document, win = window, setTimer = setTimeout, clearTimer = clearTimeout } = {}) {
  let node = null
  let safetyTimer = null
  let released = false

  function hold({ canvas, rect }) {
    // Remove any old curtain.
    if (node) {
      if (safetyTimer !== null) {
        clearTimer(safetyTimer)
        safetyTimer = null
      }
      node.remove()
      node = null
    }

    released = false

    node = doc.createElement('div')
    node.dataset.test = 'curtain'
    node.style.position = 'fixed'
    node.style.inset = '0'
    node.style.zIndex = '2147483000'
    // daisyui base colour
    node.style.background = 'var(--color-base-100, #fff)'
    node.style.opacity = '1'

    if (canvas) {
      canvas.style.position = 'absolute'
      canvas.style.left = `${rect.x}px`
      canvas.style.top = `${rect.y}px`
      canvas.style.width = `${rect.w}px`
      canvas.style.height = `${rect.h}px`
      node.appendChild(canvas)
    }

    doc.body.appendChild(node)

    // Safety timer so the curtain can never get stuck.
    safetyTimer = setTimer(() => release(150), 4000)
  }

  function morph(rect, ms) {
    if (!node) return

    if (win.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      node.style.transition = 'opacity 120ms'
      node.style.left = `${rect.x}px`
      node.style.top = `${rect.y}px`
      node.style.width = `${rect.w}px`
      node.style.height = `${rect.h}px`
      return
    }

    node.style.transition = `left ${ms}ms ease-out, top ${ms}ms ease-out, width ${ms}ms ease-out, height ${ms}ms ease-out`
    node.style.left = `${rect.x}px`
    node.style.top = `${rect.y}px`
    node.style.width = `${rect.w}px`
    node.style.height = `${rect.h}px`
  }

  function release(fadeMs = 150) {
    if (!node || released) return
    released = true

    if (safetyTimer !== null) {
      clearTimer(safetyTimer)
      safetyTimer = null
    }

    const current = node
    current.style.transition = `opacity ${fadeMs}ms`
    current.style.opacity = '0'

    setTimer(() => {
      current.remove()
      if (node === current) node = null
    }, fadeMs)
  }

  function active() {
    return node !== null
  }

  return { hold, morph, release, active }
}
